'use client';

import Link from "next/link";
import { IMenuItem } from "../../../models/IMenuItem";
import { ILocalizedParams } from '@/models/ICommon';
import { twMerge } from "tailwind-merge";
import { usePathname } from "next/navigation";

interface Props {
  menu: IMenuItem[];
}

const isSelected = (href: string, pathname: string) => {
  const strippedPath = pathname.split('?')[0].toLowerCase();
  const isPost = strippedPath.split('/').filter(x =>x).length >= 2;
  if (isPost) return strippedPath.includes(href.toLowerCase());
  else return strippedPath.endsWith(`/${href?.toLowerCase()}`);
}


export default function PagesLinks({ menu, locale }: ILocalizedParams<Props>) {
  const pathname = usePathname();
  return (
    <>
      {menu?.sort((a, b) => a.weight - b.weight).map(({ id, title, destination }) => <Link hrefLang={locale} title={title!} href={`/${destination}`} className={twMerge('dark:text-primary-100 sm', isSelected(destination, pathname) && 'text-secondary-400 dark:text-secondary-400 font-kufi-600')} key={id}>{title}</Link>)}
    </>
  )
}